import { render, staticRenderFns } from "./RiskInsiderButton.vue?vue&type=template&id=0b228ece&scoped=true"
import script from "./RiskInsiderButton.vue?vue&type=script&lang=js"
export * from "./RiskInsiderButton.vue?vue&type=script&lang=js"
import style0 from "./RiskInsiderButton.vue?vue&type=style&index=0&id=0b228ece&lang=scss&scoped=true"
import style1 from "./RiskInsiderButton.vue?vue&type=style&index=1&id=0b228ece&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b228ece",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b228ece')) {
      api.createRecord('0b228ece', component.options)
    } else {
      api.reload('0b228ece', component.options)
    }
    module.hot.accept("./RiskInsiderButton.vue?vue&type=template&id=0b228ece&scoped=true", function () {
      api.rerender('0b228ece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Home/RiskInsiderButton.vue"
export default component.exports